"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateXlsx2CsvConfig = void 0;
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("@finley-technologies/common");
const generateConfig = (calcAgentMechanics, parties) => {
    const { loanProductMechanics, multiLoanProductConcentrationLimits, } = calcAgentMechanics;
    // 1st gather common field names
    const common = {
        importRaw: true,
        sheetName: 'Borrowing Base',
        cellAddress: 'M10',
    };
    const topLevelFields = [
        'commitmentAmount',
        'currentPrincipalBalance',
        'totalReceivableExposure',
        'totalEligibilityKickout',
        'totalEligibleExposure',
        'totalConcentrationKickout',
        'borrowingBaseAmountAssets',
        'effectiveReceivableAdvanceRate',
        'weightedAverageReceivableAdvanceRate',
        'borrowingBaseReserveAmount',
        'totalPreAdvanceCashContribution',
        'effectiveCashAdvanceRate',
        'maxReceivableAdvanceAmount',
        'totalCashBorrowingBaseAmount',
        'totalBorrowingBaseAmount',
    ];
    // eligibility keys across all individual lps
    const eligibilityKeys = lodash_1.default.flatMap(loanProductMechanics, (loanProduct) => {
        return loanProduct.eligibilityTests
            .map((test) => test._config_.eligibilityTestConfig?.propertyKey)
            .filter(common_1.typeguards.isNotNullOrUndefined);
    });
    // concentration limit keys across all individual lps
    const concentrationKeys = lodash_1.default.flatMap(loanProductMechanics, (loanProduct) => {
        return loanProduct.concentrationLimits
            .map((limit) => limit._config_.concentrationLimitConfig?.propertyKey)
            .filter(common_1.typeguards.isNotNullOrUndefined);
    });
    // multi lp concentration limit keys for facility
    lodash_1.default.forEach(multiLoanProductConcentrationLimits, (multiLpConcentrationLimit) => {
        const multiLpConcentrationLimitKey = multiLpConcentrationLimit._config_?.concentrationLimitConfig
            ?.propertyKey;
        if (!lodash_1.default.isNil(multiLpConcentrationLimitKey)) {
            concentrationKeys.push(multiLpConcentrationLimitKey);
        }
    });
    const borrowerBankAccountTypes = lodash_1.default.flatMap(parties.borrowers, (borrower) => {
        return lodash_1.default.map(borrower.bankAccounts, ({ type }) => type.value);
    });
    const contributingBorrowerBankAccounts = lodash_1.default.filter(borrowerBankAccountTypes, (accountType) => common_1.typeguards.isBorrowingBaseContributionAccountType(accountType));
    const extract = [];
    topLevelFields.forEach((field) => {
        extract.push({
            ...common,
            fieldName: field,
        });
    });
    eligibilityKeys.forEach((key) => {
        const eligibilityValuesToFetch = ['eligibilityReduction'];
        eligibilityValuesToFetch.forEach((value) => {
            extract.push({
                ...common,
                fieldName: `eligibilityCriteriaCalculations#${key}#${value}`,
            });
        });
    });
    concentrationKeys.forEach((key) => {
        const concentrationLimitValuesToFetch = [
            'concentrationLimit',
            'borrowingBaseReduction',
            'concentrationAmount',
        ];
        concentrationLimitValuesToFetch.forEach((value) => {
            extract.push({
                ...common,
                fieldName: `concentrationLimitCalculations#${key}#${value}`,
            });
        });
    });
    lodash_1.default.forEach(contributingBorrowerBankAccounts, (bankAccountType) => {
        const bankAccountValuesToFetch = ['balance', 'cashAdvanceRate', 'currency'];
        bankAccountValuesToFetch.forEach((value) => {
            extract.push({
                ...common,
                fieldName: `bankAccountCashBalances#${bankAccountType}#${value}`,
            });
        });
    });
    lodash_1.default.forEach(loanProductMechanics, (loanProduct) => {
        const borrowingBaseReportLoanProductCalculationsValuesToFetch = [
            'totalReceivableExposure',
            'totalEligibilityKickout',
            'totalEligibleExposure',
            'totalConcentrationKickout',
            'totalEligibleExposureLessConcentrationKickouts',
            'weightedAverageReceivableAdvanceRate',
            'totalReceivableBorrowingBaseAmount',
            'effectiveReceivableAdvanceRate',
            'effectiveReceivableValuationRate',
        ];
        borrowingBaseReportLoanProductCalculationsValuesToFetch.forEach((value) => {
            extract.push({
                ...common,
                fieldName: `loanProductCalculations#${loanProduct.entity.slug}#${value}`,
            });
        });
    });
    // extract FundingRequestComponentTotalAmounts
    const borrowerFundingRequestComponentTotalAmounts = {
        curePaydownTotalAmount: 0,
        drawRequestTotalAmount: 0,
        collectionsRecycleTotalAmount: 0,
        collectionsPaydownTotalAmount: 0,
    };
    const borrowerFundingRequestDates = {
        curePaydownTargetFundingDate: undefined,
        drawRequestTargetFundingDate: undefined,
        collectionsRecycleTargetFundingDate: undefined,
        collectionsPaydownTargetFundingDate: undefined,
    };
    Object.keys(borrowerFundingRequestComponentTotalAmounts).forEach((key) => {
        extract.push({
            ...common,
            fieldName: `borrowerFundingRequestComponentTotalAmounts#${key}`,
        });
    });
    Object.keys(borrowerFundingRequestDates).forEach((key) => {
        extract.push({
            ...common,
            fieldName: `borrowerFundingRequestComponents#${key}`,
        });
    });
    return {
        operation: 'xlsx2csv',
        mode: 'extractValues',
        extract,
    };
};
/**
 * generate servicer report import config for (xlsx2csv node) for the given borrowing base mechanics.
 * you can use this method to auto-generate config which lists all the fields that we need to
 * import. Caller need to later substitute cellAddress and sheetName with the actual values
 */
function generateXlsx2CsvConfig({ calcAgentMechanics, parties, }) {
    return generateConfig(calcAgentMechanics, parties);
}
exports.generateXlsx2CsvConfig = generateXlsx2CsvConfig;
//# sourceMappingURL=generateXlsx2CsvConfig.js.map